import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLoupeSearch16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M7.08372 13.1738C10.4438 13.1738 13.1738 10.4501 13.1738 7.08372C13.1738 3.71731 10.4501 1 7.08372 1C3.71731 1 1 3.72368 1 7.08372C1 10.4438 3.72368 13.1738 7.09009 13.1738H7.08372Z" stroke="currentColor" strokeLinecap="square" /><path d="M15.0001 14.9998L11.3918 11.3916" stroke="currentColor" strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgLoupeSearch16);
export default ForwardRef;